import { Measurements } from '@hec/models';

export const GetTotalSurfaceSize = ({ height, width, depth }: Measurements): number => {
  return ((depth * height) * 2) + (width * height);
}
